<div class="card-body">
    <canvas height="100px" id="basic_pie_chart"></canvas>
</div>